<div id="menu-cart-orders">
    <div id="cart-orders-header">
        <div id="cart-orders-header-icon">
            <i class="fa-regular fa-cart-shopping"></i>
        </div>
        <p>{{ 'cartOrdersMenu.incompleteOrders' | translate }}</p>
    </div>

    @if (!isLoadingData) {
        @if (cartOrders.length) {
            <div
                id="cart-orders-content"
                #cartOrdersContentTemplate
                [style.max-height]="(cartOrdersContentTemplate.scrollHeight / cartOrders.length) * 5 + 'px'">
                @for (cartOrder of cartOrders; track cartOrder; let index = $index) {
                    <div class="order-container">
                        <div class="order-details">
                            <a
                                class="order-name"
                                [id]="'order-name-' + index"
                                [routerLink]="[appRoutes.routes().ORDERS_SETUP, cartOrder.orderId]"
                                >{{ cartOrder.orderName }}</a
                            >
                            <div class="order-subdetails">
                                <p>
                                    {{ 'cartOrdersMenu.order.numberOfReactions' | translate }}:
                                    {{ cartOrder.numberOfReactions }}
                                </p>
                                <div class="dot"></div>
                                <p>
                                    {{ 'cartOrdersMenu.order.lastSaved' | translate }}:
                                    {{ cartOrder.lastSaved | date: 'MM/dd/YYYY' }}
                                </p>
                            </div>
                        </div>
                        <p-button
                            class="delete-order-button"
                            icon="fa-light fa-trash-can-xmark"
                            severity="danger"
                            [id]="'delete-order-btn-' + index"
                            [text]="true"
                            (click)="displayDeleteOrderModal(cartOrder.orderId)">
                        </p-button>
                    </div>
                }
            </div>
        } @else {
            <div class="empty-state-container">
                <img
                    width="48"
                    height="44"
                    [ngSrc]="'assets/images/illustrations/shopping-cart.svg'"
                    [alt]="'img.alt.shoppingCart' | translate" />
                <p>{{ 'cartOrdersMenu.emptyState.firstSentence' | translate }}</p>
                <i>{{ 'cartOrdersMenu.emptyState.secondSentence' | translate }}</i>
                <p-button
                    id="start-an-order-btn"
                    size="small"
                    [outlined]="true"
                    [routerLink]="appRoutes.routes().ORDERS_SETUP">
                    {{ 'cartOrdersMenu.emptyState.startAnOrder' | translate }}
                </p-button>
            </div>
        }
        @if (cartOrders.length) {
            <div id="view-all-incomplete-orders-btn-container">
                <p-button
                    id="view-all-incomplete-orders-btn"
                    size="small"
                    [outlined]="true"
                    [routerLink]="appRoutes.routes().ORDERS_LIST"
                    [queryParams]="{ status: orderStatuses.INCOMPLETE }">
                    {{ 'cartOrdersMenu.order.viewAllIncompleteOrders' | translate }}
                </p-button>
            </div>
        }
    } @else {
        <app-loader></app-loader>
    }
</div>
